export default "__VITE_ASSET__6e65fad5__"